"use client";

import { TimeInput as HeroTimeInput } from "@heroui/react";
import { cn } from "../../lib/utils";

export const TimeInput = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroTimeInput>) => {
  return <HeroTimeInput className={cn(className)} {...props} />;
};
